export enum InvoiceDispatchType {
  /**
   * Alle
   */
  ALL = 'ALL',
  /**
   * E-mail
   */
  EMAIL = 'EMAIL',
  /**
   * Postversand
   */
  POST = 'POST',
}
